import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { Box, Tabs, Flex, Text, Heading } from '@workwhile/ui'
import { useI9HubContextValue } from '../../context/I9HubProvider'
import { I9AltDocsHubFilters } from '../../components/I9HubFilters/I9AltDocsHubFilters'
import { I9ReverificationQueueMain } from './I9ReverificationQueueMain'

function AlternateDocumentsHubPlaceholder() {
  const {
    state: {
      altDocs: { groupedItems, filteredItems },
    },
  } = useI9HubContextValue()

  return (
    <Flex flexDirection="column" gap={3} mt={3}>
      <Text color="lightText">
        Alternate documents queue UI is not wired yet. Filters and grouping are
        active in the URL and will apply once data is available.
      </Text>
      <Flex justifyContent="left" alignItems="center" mb={3}>
        <I9AltDocsHubFilters />
      </Flex>
      <Box>
        <Text fontWeight="bold" mb={2}>
          Preview ({filteredItems.length} rows)
        </Text>
        {groupedItems.length === 0 ? (
          <Text>No alternate document rows yet.</Text>
        ) : (
          groupedItems.map(([group, rows]) => (
            <Box key={group} mb={2}>
              <Text fontWeight="bold">{group}</Text>
              <Text fontSize={1} color="lightText">
                {rows.length} row(s)
              </Text>
            </Box>
          ))
        )}
      </Box>
    </Flex>
  )
}

function tabLabel(title: string, count: number) {
  return count > 0 ? `${title} (${count} to review)` : title
}

export function I9ManagementMain() {
  const [searchParams, setSearchParams] = useSearchParams()
  const {
    state: {
      counts: { alternateDocuments, i9Reverification },
    },
  } = useI9HubContextValue()

  const tabParam = searchParams.get('tab')
  const tab =
    tabParam === 'i9_reverification'
      ? 'i9_reverification'
      : 'alternate_documents'

  return (
    <Box margin={3}>
      <Heading level={1} mb={3}>
        I-9 Hub
      </Heading>
      <Box mb={4} />
      <Tabs
        value={tab}
        onValueChange={(value) => {
          const next = new URLSearchParams(searchParams)
          next.set('tab', value)
          setSearchParams(next)
        }}
        tabs={[
          {
            value: 'alternate_documents',
            label: tabLabel('Alternate Documents', alternateDocuments),
          },
          {
            value: 'i9_reverification',
            label: tabLabel('I-9 Reverification', i9Reverification),
          },
        ]}
      >
        <Tabs.Content value="alternate_documents">
          <AlternateDocumentsHubPlaceholder />
        </Tabs.Content>
        <Tabs.Content value="i9_reverification">
          <I9ReverificationQueueMain />
        </Tabs.Content>
      </Tabs>
    </Box>
  )
}
